{
	"title": "Tranzacția nu a fost găsită",
	"description": "Vă rugăm să mergeți la prezentare generală și să introduceți un ID de tranzacție valid. Un ID de tranzacție poate fi găsit pe o declarație sau pe o factură.",
	"secondaryButtonTitle": "Afișează pagina de start"
}
